<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    title="请选择可使用部门"
    width="360px"
    append-to-body
  >
    <div class="SiruiModalHeight">
      <el-select v-model="departmentCode" multiple style="width: 100%">
        <el-option
          v-for="item in departmentList"
          :key="item.value"
          :value="item.value"
          :label="item.label"
          :disabled="item.disabled"
        ></el-option>
      </el-select>
    </div>
    <div class="search-modal-footer">
      <el-button type="primary" @click="confirmHandler">
        <span class="footer-button">确认</span>
      </el-button>
      <el-button @click="cancelHandler">
        <span class="footer-button">{{ $t('dialog.cancel') }}</span>
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'SetUsageDepartmentDialog',
    props: {
      departmentList: {
        required: true,
        type: Array,
      },
      defaultDepartmentCode: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        dialogVisible: false,
        departmentCode: [],
        selectList: [],
      };
    },
    watch: {
      defaultDepartmentCode: {
        handler(list) {
          this.departmentCode = list;
          this.departmentList.map((v) => {
            if (v.departmentCode == list[0]) {
              v.disabled = true;
            }
            return v;
          });
        },
        immediate: true,
      },
    },
    methods: {
      confirmHandler() {
        const codeStr = this.departmentCode.join(',');
        const nameStr = this.departmentCode
          .map((v) => {
            return this.departmentList.find((it) => it.value == v).label;
          })
          .join(',');
        this.$emit('confirm', codeStr, nameStr);
      },
      cancelHandler() {
        this.departmentCode = [];
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .search-modal-footer {
    margin-top: 24px;
  }
</style>
